"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var NestedProjectExplorerCell_1 = require("./NestedProjectExplorerCell");
var widgets_1 = require("@tableau/widgets");
var TreeViewComponent_1 = require("../TreeViewComponent");
// These should ideally be consumed from shared widgets TabStyles
// for visual consistency throughout the product
var SmallIconSize = 17;
var DataGridRowDividerLineWidth = 1;
var GridIconStyle = {
    display: 'inline-block',
    verticalAlign: 'top',
    width: SmallIconSize,
    height: TreeViewComponent_1.TreeViewComponent.RowHeight - DataGridRowDividerLineWidth,
    marginRight: widgets_1.TabStyles.Spacing.DefaultSpace,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    backgroundSize: SmallIconSize,
};
function gridIconStyleWithBackgroundImage(imageDataUri) {
    return __assign(__assign({}, GridIconStyle), { backgroundImage: "url(" + imageDataUri + ")" });
}
function ProjectCellComponent(props) {
    return (React.createElement("div", { "data-tb-test-id": props.testId || 'project-cell', style: NestedProjectExplorerCell_1.ContainerStyle },
        props.iconDataUri && React.createElement("span", { "data-tb-test-id": 'data-grid-cell-icon', style: gridIconStyleWithBackgroundImage(props.iconDataUri), title: props.hideTooltips ? undefined : props.iconTitle }),
        React.createElement("span", { "data-tb-test-id": 'data-grid-cell-text', title: props.hideTooltips ? undefined : (props.title || props.text) }, props.text)));
}
exports.ProjectCellComponent = ProjectCellComponent;
//# sourceMappingURL=ProjectCellComponent.js.map